function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.24 17a1 1 0 010-2h15.43l-4.106-3.763a1 1 0 011.352-1.474l5.598 5.131a1.5 1.5 0 010 2.212l-5.598 5.131a1 1 0 01-1.352-1.474L27.67 17H12.24z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 4a1 1 0 011 1v5.5a1 1 0 102 0V5a3 3 0 00-3-3H5a3 3 0 00-3 3v22a3 3 0 003 3h13a3 3 0 003-3v-5.5a1 1 0 10-2 0V27a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h13z",
  fill: "currentColor"
})));